import React from 'react'
import { motion } from 'framer-motion'

const CrimeStructureDiagram: React.FC = () => {
  return (
    <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/20 p-6">

      
             <div className="relative">
         {/* Главный заголовок */}
         <div className="bg-gradient-to-r from-purple-500/20 to-blue-500/20 border border-purple-500/30 rounded-lg p-4 mb-8 text-center">
           <h3 className="text-2xl font-bold text-white">СОСТАВ ПРЕСТУПЛЕНИЯ</h3>
         </div>
         
         {/* Стрелка вниз от главного заголовка */}
         <div className="flex justify-center mb-6">
           <div className="w-0.5 h-8 bg-gradient-to-b from-purple-400 to-transparent"></div>
         </div>
         
         <div className="flex justify-center items-start gap-8 mb-6">
           {/* Объективные признаки */}
           <motion.div 
             initial={{ opacity: 0, x: -20 }}
             animate={{ opacity: 1, x: 0 }}
             transition={{ duration: 0.5 }}
             className="flex-1"
           >
             <div className="bg-blue-500/20 border border-blue-500/30 rounded-lg p-3 mb-4 relative">
               <h4 className="text-lg font-semibold text-blue-300 text-center">Объективные признаки</h4>
               {/* Стрелка вниз */}
               <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full w-0.5 h-4 bg-blue-400"></div>
             </div>
             
             <div className="space-y-4">
               {/* ОБЪЕКТ */}
               <div className="bg-gray-600/20 border border-gray-500/30 rounded-lg p-3 relative">
                 <h5 className="text-md font-semibold text-gray-300 mb-2">ОБЪЕКТ</h5>
                 <div className="space-y-1">
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">предмет</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">потерпевший</div>
                 </div>
                 {/* Стрелка вниз */}
                 <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full w-0.5 h-3 bg-gray-400"></div>
               </div>
               
               {/* ОБЪЕКТИВНАЯ СТОРОНА */}
               <div className="bg-gray-600/20 border border-gray-500/30 rounded-lg p-3">
                 <h5 className="text-md font-semibold text-gray-300 mb-2">ОБЪЕКТИВНАЯ СТОРОНА</h5>
                 <div className="space-y-1">
                   <div className="bg-red-500/30 border border-red-400/50 rounded px-2 py-1 text-sm text-red-200 font-medium">деяние</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">последствия</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">причинная связь</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">время</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">место</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">способ</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">орудия и средства</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">обстановка</div>
                 </div>
               </div>
             </div>
           </motion.div>
           
           {/* Знак + с стрелками */}
           <motion.div 
             initial={{ opacity: 0, scale: 0 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5, delay: 0.3 }}
             className="flex flex-col items-center justify-center gap-2"
           >
             {/* Стрелка слева */}
             <div className="w-8 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400"></div>
             
             <div className="flex items-center justify-center w-12 h-12 bg-purple-500/20 border border-purple-500/30 rounded-full text-2xl font-bold text-purple-300">
               +
             </div>
             
             {/* Стрелка справа */}
             <div className="w-8 h-0.5 bg-gradient-to-r from-purple-400 to-green-400"></div>
           </motion.div>
           
           {/* Субъективные признаки */}
           <motion.div 
             initial={{ opacity: 0, x: 20 }}
             animate={{ opacity: 1, x: 0 }}
             transition={{ duration: 0.5, delay: 0.2 }}
             className="flex-1"
           >
             <div className="bg-green-500/20 border border-green-500/30 rounded-lg p-3 mb-4 relative">
               <h4 className="text-lg font-semibold text-green-300 text-center">Субъективные признаки</h4>
               {/* Стрелка вниз */}
               <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full w-0.5 h-4 bg-green-400"></div>
             </div>
             
             <div className="space-y-4">
               {/* СУБЪЕКТ */}
               <div className="bg-gray-600/20 border border-gray-500/30 rounded-lg p-3 relative">
                 <h5 className="text-md font-semibold text-gray-300 mb-2">СУБЪЕКТ</h5>
                 <div className="space-y-1">
                   <div className="bg-red-500/30 border border-red-400/50 rounded px-2 py-1 text-sm text-red-200 font-medium">возраст</div>
                   <div className="bg-red-500/30 border border-red-400/50 rounded px-2 py-1 text-sm text-red-200 font-medium">вменяемость</div>
                   <div className="bg-red-500/30 border border-red-400/50 rounded px-2 py-1 text-sm text-red-200 font-medium">физическое лицо</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">специальные признаки</div>
                 </div>
                 {/* Стрелка вниз */}
                 <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full w-0.5 h-3 bg-gray-400"></div>
               </div>
               
               {/* СУБЪЕКТИВНАЯ СТОРОНА */}
               <div className="bg-gray-600/20 border border-gray-500/30 rounded-lg p-3">
                 <h5 className="text-md font-semibold text-gray-300 mb-2">СУБЪЕКТИВНАЯ СТОРОНА</h5>
                 <div className="space-y-1">
                   <div className="bg-red-500/30 border border-red-400/50 rounded px-2 py-1 text-sm text-red-200 font-medium">вина</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">мотив</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">цель</div>
                   <div className="bg-gray-500/20 border border-gray-400/30 rounded px-2 py-1 text-sm text-gray-200">эмоции</div>
                 </div>
               </div>
             </div>
           </motion.div>
         </div>
       </div>
      
      {/* Легенда */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.4 }}
        className="flex justify-end items-center gap-4 text-sm"
      >
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-red-500/30 border border-red-400/50 rounded"></div>
          <span className="text-gray-300">Обязательные признаки</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-gray-500/20 border border-gray-400/30 rounded"></div>
          <span className="text-gray-300">Факультативные признаки</span>
        </div>
      </motion.div>
    </div>
  )
}

export default CrimeStructureDiagram
